import React from "react";
import AppBar from "../app-bar/app-bar";
import AllNotification from "./all-notifications";
import {useUser} from "../providers/user-context";

function AllNotificationsPage({navOpen, toggleNav}) {
    const {userFullName, tenantName, tenantType} = useUser();
    return (
        <div style={{ display: 'flex', marginTop: '60px' }}>
            <AppBar userFullName={userFullName} tenantName={tenantName} type={tenantType} navOpen={navOpen} toggleNav={toggleNav}/>
            {["IMPORTER", "PHARMACY"].includes(tenantType) && <AllNotification navOpen={navOpen}/>}
        </div>
    );
}
export default AllNotificationsPage;
